import { supabase } from 'api/axios.instance'
import { statisticEssentialQuery } from '../common'

const table = 'statistics_total_tutor'

export const getStatisticTutor = async regionId => {
    try {
        return await statisticEssentialQuery(table, regionId)
    } catch (error) {
        console.error(error)
        return null
    }
}

export const getTotalTutorStatistics = async year => {
    const { data, error } = await supabase.from(table).select().eq('year', year).order('id', { ascending: true })

    if (error) throw new Error(error.message)
    return data
}
